// Toast 
// usage: Toast.show(msg, type, timeout);

import 'noty/src/noty.scss';
import 'noty/src/themes/mint.scss';

// Toast types ...
const types = ['error', 'info', 'warning', 'success', 'alert'];
// check Noty type validity ...
const isValidType = type => (types.indexOf(type) >= 0);
// check Noty existing instance ...
const hasNotyInstance = () => {
    return (typeof window !== 'undefined' && typeof window.Noty === 'function');
};

export default class Toast {

    // Display Noty
    static show = (text = 'Success!', type = 'success', timeout = 3000) => {
        try {
            let hasError = false;
            // check existing Noty lib ...
            if (!hasNotyInstance()) window.Noty = require('noty');

            // set Noty instances
            let toast = new window.Noty({ type, layout: 'bottomCenter', text, timeout });

            // validate Noty type
            if (!isValidType(type)) {
                toast.setType('success', true);
                hasError = true;
            }

            if (type === 'error') {
                toast = new window.Noty({ type, layout: 'bottom', text, timeout });
            }

            toast.show();

            // displays warning after timeout + 1s
            if (hasError) {
                const errTout = timeout + 1000;
                setTimeout(() => {
                    Toast.show(
                        `Error: Invalid '${type}' as a Noty type => ['error', 'info', 'warning', 'success', 'alert']`,
                        'warning',
                        timeout
                    );
                }, errTout);
            }
        } catch (error) {
            // console.log('[Noty Error]: ', error);
        }
    }
}